// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4a41bfb1","355":"d0783a64","553":"80193866","977":"eacef705"}[chunkId] + ".chunk.js";
};